import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=337b422d&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style1 from "./Index.vue?vue&type=style&index=1&id=337b422d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337b422d",
  null
  
)

export default component.exports